import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Inter autoalojado: la app no depende de un CDN, que en una VM del cliente puede no tener
// salida a internet. Graphik va primero en la pila de `--fuente` (ver estilos.css).
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "./estilos.css";
import "./layout.css";

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
